import React from "react";
import { HiMenuAlt2 } from "react-icons/hi";
import { MdCancel } from "react-icons/md";
import { CiBellOn } from "react-icons/ci";

const Header = () => {
  return (
    <div className="header">
      <div className="dashboard">
        <HiMenuAlt2 className="icon1" />
        <MdCancel className="icon2" />
        <span>Dashboard</span>
      </div>

      <div className="dashboard-icon">
        <div className="icon-d">
          <CiBellOn />
         
        </div>

        <div className="profile-ca">
          <img src="/profile.png" />
          <span>Abdullahi B</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
